<template>
  <div class="param-report-page p-4">
    <!-- Header Area -->
    <div class="d-flex align-items-center mb-4 pb-2 border-bottom">
      <b-button variant="white" @click="goback()" class="mr-3 rounded-circle shadow-sm border btn-back">
        <b-icon icon="arrow-left" variant="primary"></b-icon>
      </b-button>
      <h3 class="mb-0 font-weight-bold text-dark page-title">{{ $route.query.desc }}</h3>
    </div>

    <b-row justify="center">
      <b-col lg="10" xl="8" class="mx-auto">
        <b-card no-body class="report-card shadow border-0 rounded-lg overflow-hidden">
          <div class="card-header-gradient p-3 text-white">
            <h5 class="mb-0 font-weight-bold">
              <b-icon icon="filter-square-fill" class="mr-2"></b-icon> ກຳນົດເງື່ອນໄຂການດຶງລາຍງານ
            </h5>
          </div>

          <b-card-body class="p-4 p-md-5 bg-white">
            <b-form @submit.prevent="onPreview">
              <b-row>
                <!-- Geographic and Org Selection -->
                <b-col md="6">
                  <b-form-group :label="$t('users.branch_id')" label-class="label-style">
                    <b-form-select 
                      v-model="fld.prov_id" 
                      :options="provices" 
                      required 
                      @input="getDep" 
                      class="custom-select-styled"
                    ></b-form-select>
                  </b-form-group>
                </b-col>

                <b-col md="6">
                  <b-form-group :label="$t('users.dep_code')" label-class="label-style">
                    <b-form-select 
                      v-model="fld.district_id" 
                      :options="dep" 
                      required 
                      @input="getscholls" 
                      class="custom-select-styled"
                    ></b-form-select>
                  </b-form-group>
                </b-col>

                <b-col md="12">
                  <b-form-group :label="$t('users.scholl')" label-class="label-style">
                    <multiselect 
                      v-model="value" 
                      :options="schools" 
                      placeholder="ເລືອກໂຮງຮຽນ" 
                      label="text"
                      track-by="text"
                      class="custom-multiselect shadow-sm"
                    ></multiselect>
                  </b-form-group>
                </b-col>

                <b-col md="12">
                  <b-form-group label="ແຫຼ່ງທຶນ" label-class="label-style">
                    <b-form-select 
                      v-model="fld.source_type" 
                      :options="source_types" 
                      required 
                      class="custom-select-styled"
                    ></b-form-select>
                  </b-form-group>
                </b-col>

                <!-- Academic Year Selection -->
                <b-col md="12">
                  <b-form-group label="ສົກຮຽນ:" label-class="label-style">
                    <b-input-group class="shadow-sm rounded overflow-hidden">
                      <b-form-input v-model="fld.accd" v-mask="'####-####'" placeholder="____-____" trim class="custom-input-styled"></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>

              <div class="mt-5 pt-3 text-center">
                <b-button type="submit" variant="primary" class="preview-btn px-5 py-3 shadow-lg rounded-pill font-weight-bold">
                  <b-icon icon="file-earmark-bar-graph" class="mr-2"></b-icon> {{ $t('button.preview') }}
                </b-button>
              </div>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import axios from "axios";
 import Multiselect from 'vue-multiselect'
 
export default {
    components: { Multiselect },

    data() {
        return {
            value:{ value: "0000000", text: "ທຸກໂຮງຮຽນ" },
            provices: [{ value: "00", text: "ທຸກແຂວງ" },],
            dep: [{ value: "0000", text: "ທຸກເມືອງ" },],
            schools:[{ value: "0000000", text: "ທຸກໂຮງຮຽນ" },],
            source_types:[],
            user:[],

            fld: {
                fromdate: "",
                todate: "",
                prov_id: "",
                district_id:"",
                school_id: "",
                reportname: this.$route.query.reportname,
                branch_id:'',
                params:"",
                source_type:"",
                accd:""

            },
             
            month: '',
            yyyy: '',
            mm: [
                { value: 1, text: "1" },
                { value: 2, text: "2" },
                { value: 3, text: "3" },
                { value: 4, text: "4" },
                { value: 5, text: "5" },
                { value: 6, text: "6" },
                { value: 7, text: "7" },
                { value: 8, text: "8" },
                { value: 9, text: "9" },
                { value: 10, text: "10" },
                { value: 11, text: "11" },
                { value: 12, text: "12" },

            ],
            quater: '',
            qq: [
                { value: 1, text: "1" },
                { value: 2, text: "2" },
                { value: 3, text: "3" },
                { value: 4, text: "4" },
            ]
        }
    },
    created() {
        let login = localStorage.getItem("Login");
        this.user = JSON.parse(login);
        this.fld.branch_id=this.user.branch_id
        this.fld.prov_id=this.user.prov_id
        this.fld.district_id=this.user.district_id
        this.fld.school_id=this.user.school_id

        if(this.user.org_type_code==1){
            axios
            .get(
                this.$store.getters.getBaseUrl +
                "/getItems/province/prov_name/prov_id",
                {
                    headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                }
            )
            .then((response) => {
                // JSON responses are automatically parsed.
                this.provices = response.data;
                //    console.log(  JSON.parse(response.data))
            })
            .catch((e) => {
                console.log(e);
            });

            axios
                .get(
                    this.$store.getters.getBaseUrl +
                    "/getItemsCondition/district/district_name_lao/district_id/prov_id/" + this.fld.prov_id,
                    {
                        headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                    }
                )
                .then((response) => {
                    // JSON responses are automatically parsed.
                    this.dep = response.data;
                    //    console.log(  JSON.parse(response.data))
                })

                axios
                .get(
                    this.$store.getters.getBaseUrl +
                    "/getItemsCondition/schools/school_name_lao/school_id/district_id/" + this.fld.district_id,
                    {
                        headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                    }
                )
                .then((response) => {
                    // JSON responses are automatically parsed.
                    this.schools = response.data;
                   //   console.log(  JSON.parse(this.scholls))
                })



          
        }else if(this.user.org_type_code==2){
            axios
            .get(
                this.$store.getters.getBaseUrl +
                "/getItemsCondition/province/prov_name/prov_id/prov_id/"+this.user.prov_id,
                {
                    headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                }
            )
            .then((response) => {
                // JSON responses are automatically parsed.
                this.provices = response.data;
                //    console.log(  JSON.parse(response.data))
            })
            .catch((e) => {
                console.log(e);
            });


            axios
                .get(
                    this.$store.getters.getBaseUrl +
                    "/getItemsCondition/district/district_name_lao/district_id/prov_id/" + this.fld.prov_id,
                    {
                        headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                    }
                )
                .then((response) => {
                    // JSON responses are automatically parsed.
                    this.dep = response.data;
                    //    console.log(  JSON.parse(response.data))
                })


                axios
                .get(
                    this.$store.getters.getBaseUrl +
                    "/getItemsCondition/schools/school_name_lao/school_id/district_id/" + this.fld.district_id,
                    {
                        headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                    }
                )
                .then((response) => {
                    // JSON responses are automatically parsed.
                    this.schools = response.data;
                   //   console.log(  JSON.parse(this.scholls))
                })



        }else if(this.user.org_type_code==3){
            axios
            .get(
                this.$store.getters.getBaseUrl +
                "/getItemsCondition/province/prov_name/prov_id/prov_id/"+this.user.prov_id,
                {
                    headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                }
            )
            .then((response) => {
                // JSON responses are automatically parsed.
                this.provices = response.data;
                //    console.log(  JSON.parse(response.data))
            })
            .catch((e) => {
                console.log(e);
            });


            axios
                .get(
                    this.$store.getters.getBaseUrl +
                    "/getItemsCondition/district/district_name_lao/district_id/district_id/" + this.fld.district_id,
                    {
                        headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                    }
                )
                .then((response) => {
                    // JSON responses are automatically parsed.
                    this.dep = response.data;
                    //    console.log(  JSON.parse(response.data))
                })
                

                axios
                .get(
                    this.$store.getters.getBaseUrl +
                    "/getItemsCondition/schools/school_name_lao/school_id/district_id/" + this.fld.district_id,
                    {
                        headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                    }
                )
                .then((response) => {
                    // JSON responses are automatically parsed.
                    this.schools = response.data;
                   //   console.log(  JSON.parse(this.scholls))
                })



        }

        else if(this.user.org_type_code==4){
            axios
            .get(
                this.$store.getters.getBaseUrl +
                "/getItemsCondition/province/prov_name/prov_id/prov_id/"+this.user.prov_id,
                {
                    headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                }
            )
            .then((response) => {
                // JSON responses are automatically parsed.
                this.provices = response.data;
                //    console.log(  JSON.parse(response.data))
            })
            .catch((e) => {
                console.log(e);
            });


            axios
                .get(
                    this.$store.getters.getBaseUrl +
                    "/getItemsCondition/district/district_name_lao/district_id/district_id/" + this.fld.district_id,
                    {
                        headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                    }
                )
                .then((response) => {
                    // JSON responses are automatically parsed.
                    this.dep = response.data;
                    //    console.log(  JSON.parse(response.data))
                })
                

                axios
                .get(
                    this.$store.getters.getBaseUrl +
                    "/getItemsCondition/schools/school_name_lao/school_id/school_id/" + this.fld.school_id,
                    {
                        headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                    }
                )
                .then((response) => {
                    // JSON responses are automatically parsed.
                    this.schools = response.data;
                   //   console.log(  JSON.parse(this.scholls))
                })



        }


        axios
            .get(
                this.$store.getters.getBaseUrl +
                "/getItems/source_types/source_type_desc/source_type",
                {
                    headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                }
            )
            .then((response) => {
                // JSON responses are automatically parsed.
                this.source_types = response.data;
                //    console.log(  JSON.parse(response.data))
            })
            .catch((e) => {
                console.log(e);
            });
            //source_types

        /*
        axios
            .get(
                this.$store.getters.getBaseUrl +
                "/getItems/provinces/province_lao/prov_id"
            )
            .then((response) => {
                // JSON responses are automatically parsed.
                this.provices = response.data;
                //    console.log(  JSON.parse(response.data))
            })
            .catch((e) => {
                console.log(e);
            });
            */

    },
    methods: {
        goback() {
            this.$router.go(-1)
        },

        getBorders() {
            //getItemsCondition
            axios
                .get(
                    this.$store.getters.getBaseUrl +
                    "/getItemsCondition/district/district_name_lao/district_id/prov_id/" + this.fld.prov_id,
                )
                .then((response) => {
                    // JSON responses are automatically parsed.
                    this.borders = response.data;
                    //    console.log(  JSON.parse(response.data))
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        onPreview() {
            this.fld.caption="ສົກຮຽນ: " + this.fld.accd
            this.fld.school_id=this.value.value;
            let data = JSON.stringify(this.fld);
            this.$router.push('/view_dna_api/rpt_dialys_accd/slfis_daily_report.mrt?data=' + data)
        },
        fnEnofmonth(){
        
           // var date = new Date();
           // var firstDay = new Date(this.yyyy, parseInt(this.month)-1, 1);
            var lastDay = new Date(this.yyyy , parseInt(this.month) , 0);
            var firstDay1 =    this.yyyy + '-' +(lastDay.getMonth() +1) +'-01' ;
            var lastDayWithSlashes =   this.yyyy + '-'+(lastDay.getMonth() +1) +'-'+(lastDay.getDate()) ;
           
           // $('#from_date').val(firstDay1);
           // $('#to_date').val(lastDayWithSlashes);
           // $('#yy').val($('#yyyy').val());
            this.fld.fromdate=firstDay1
            this.fld.todate=lastDayWithSlashes
           // var m=parseInt(this.month);
          // console.log(firstDay1)
        

        },
         fnEnofmonth_quarter(){
        
           // var date = new Date();
           // var firstDay = new Date(this.yyyy, parseInt(this.month)-1, 1);
           // let mmm=this.quater

            var lastDay = new Date(this.yyyy , parseInt(this.quater) , 0);
            var firstDay1 =    this.yyyy + '-' +(lastDay.getMonth() +1) +'-01' ;
             var lastDay2 = new Date(this.yyyy , parseInt(this.quater*3) , 0);
            var lastDayWithSlashes =   this.yyyy + '-'+(lastDay2.getMonth() +1) +'-'+(lastDay2.getDate()) ;
           
           // $('#from_date').val(firstDay1);
           // $('#to_date').val(lastDayWithSlashes);
           // $('#yy').val($('#yyyy').val());
            this.fld.fromdate=firstDay1
            this.fld.todate=lastDayWithSlashes
           // var m=parseInt(this.month);
          // console.log(firstDay1)
        

        },
        getDep() {
            //getItemsCondition
            axios
                .get(
                    this.$store.getters.getBaseUrl +
                    "/getItemsCondition/district/district_name_lao/district_id/prov_id/" + this.fld.prov_id,
                    {
                        headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                    }
                )
                .then((response) => {
                    // JSON responses are automatically parsed.
                    this.dep = response.data;
                    //    console.log(  JSON.parse(response.data))
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        getscholls(){
            axios
                .get(
                    this.$store.getters.getBaseUrl +
                    "/getItemsCondition/schools/school_name_lao/school_id/district_id/" + this.fld.district_id,
                    {
                        headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                    }
                )
                .then((response) => {
                    // JSON responses are automatically parsed.
                    this.schools = response.data;
                   //   console.log(  JSON.parse(this.scholls))
                })
                .catch((e) => {
                    console.log(e);
                });
        }
    },
}
</script>
<style scoped>
.param-report-page {
    background-color: #f7fafc;
    min-height: 100vh;
    font-family: 'Noto Sans Lao', sans-serif;
}

.btn-back {
    transition: all 0.3s ease;
}
.btn-back:hover {
    background-color: #ebf8ff;
    transform: translateX(-3px);
}

.page-title {
    color: #2d3748;
    letter-spacing: -0.5px;
}

.report-card {
    border-radius: 16px !important;
}

.card-header-gradient {
    background: linear-gradient(135deg, #1B4F72 0%, #2874A6 100%);
}

.label-style {
    font-weight: 700 !important;
    color: #4a5568 !important;
    font-size: 0.85rem !important;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 8px !important;
}

.custom-select-styled, .custom-input-styled {
    border-radius: 8px !important;
    border: 1px solid #e2e8f0 !important;
    height: 48px !important;
    transition: border-color 0.2s;
}
.custom-select-styled:focus, .custom-input-styled:focus {
    border-color: #3182ce !important;
    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.15) !important;
}

.preview-btn {
    min-width: 250px;
    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    background: #1B4F72;
    border: none;
    font-size: 1.1rem;
}
.preview-btn:hover {
    background: #154360;
    transform: translateY(-4px);
    box-shadow: 0 10px 20px rgba(27, 79, 114, 0.3) !important;
}

/* Customize Vue Multiselect to match the theme */
::v-deep .multiselect__tags {
    border-radius: 8px !important;
    border: 1px solid #e2e8f0 !important;
    min-height: 48px;
    padding: 8px 40px 0 12px;
}
::v-deep .multiselect__placeholder {
    margin-top: 5px;
}
</style>